import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
let FormErrorStateMatcher = class FormErrorStateMatcher {
    isErrorState(control, form) {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
};
FormErrorStateMatcher = __decorate([
    Injectable()
], FormErrorStateMatcher);
export { FormErrorStateMatcher };
